
<template>
<div class="no-padding row">
    <successModal  ref="success_modal" v-on:confirm="closeSuccessModal"></successModal>
     <v-navigation-drawer v-if="overlay" permanent cols="12" :class="display ? 'col-md-3 onMobile' : 'onMobile' " >
       <div class="filter-sideBar">
          <div>
             <div class="row no-padding justify-space-between">
                <h3 class=" font">
                  Group NPI Filters
                </h3>
                <h6 class="pointer mr-2" @click="overlay = false">x</h6>
            </div>
            <div class="col-md-12 font">
              <div class="row col-md-11 justify-space-between no-padding no-margin">
                <div class="no-padding text-gray">Selected Filter</div>
                <div class="underline-text text-gray pointer" @click="clearAll">Clear All</div>
              </div>
              <div class="row">
                  <v-btn v-if="filter.type" class=" text-center mb-2 ml-2 mr-2 col-md-4" small color="light">
                    {{filter.type.value}}
                    <v-icon
                      right
                      dark
                      small
                      @click="removeFilter('type')"
                    >
                     mdi-delete
                  </v-icon>
                </v-btn>
                 <v-btn v-if="filter.distance" class=" text-center mb-2 ml-2 mr-2 col-md-6" small color="light">
                   Distance: {{filter.distance}}
                    <v-icon
                      right
                      dark
                      small
                      @click="removeFilter('distance')"
                    >
                     mdi-delete
                  </v-icon>
                </v-btn>
                 <v-btn v-if="filter.rating" class=" text-center mb-2 ml-2 mr-2 col-md-4" small color="light">
                   Rating: {{filter.rating}}
                    <v-icon
                      right
                      dark
                      small
                      @click="removeFilter('rating')"
                    >
                     mdi-delete
                  </v-icon>
                </v-btn>
                <v-btn v-if="filter.status" class=" text-center mb-2 ml-2 mr-2 col-md-6" small color="light">
                    {{filter.status.text}}
                    <v-icon
                      right
                      @click="removeFilter('status')"
                      dark
                      small
                    >
                     mdi-delete
                  </v-icon>
                </v-btn>

                <v-btn v-if="filter.preferredProvider" class=" text-center mb-2 ml-2 mr-2 col-md-9" small color="light">
                      <span>
                         {{filter.preferredProvider.text}}
                      </span>
                    <v-icon
                      right
                      dark
                      small
                       @click="removeFilter('preferred')"
                    >
                     mdi-delete
                  </v-icon>
                </v-btn>
                    <v-btn v-if="filter.manualOverride" class=" text-center mb-2 ml-2 mr-2 col-md-8"  small color="light">
                    <span>
                       {{filter.manualOverride.text}}
                      </span> 
                    <v-icon
                      right
                       @click="removeFilter('manual')"
                      dark
                      small
                    >
                     mdi-delete
                  </v-icon>
                </v-btn>

              </div>
            </div>
           
               <v-expansion-panels accordion multiple v-model.trim="panel">
                    <v-expansion-panel>
                      <v-expansion-panel-header class="text-gray">NPI Type</v-expansion-panel-header>
                      <v-expansion-panel-content>
                          <v-radio-group v-model.trim="filter.type">
                              <v-radio
                               @click="selectedArray.push(filter.type.text)"
                                v-for="n in providerType"
                                :key="n.value"
                                :label="n.text"
                                :value="n"

                              ></v-radio>
                        </v-radio-group>
                        <span class="blue--text pointer">Show More</span>
                         </v-expansion-panel-content>
                    </v-expansion-panel>
                     <v-expansion-panel >
                      <v-expansion-panel-header class="text-gray"> Provider Radius Distance</v-expansion-panel-header>
                      <v-expansion-panel-content class="">
                              <div class="row">
                                <v-col  class="row  ml-2 col-md-9 no-padding">
                                  <div class="col-md-3 no-padding">
                                      <v-text-field solo value="30" v-model.trim="filter.distance"  ></v-text-field>
                                  </div>
                                  <div class="col-md-8 no-padding  mt-3 ml-2">
                                      <span class="text-gray small-text " >Distance in Miles</span>
                                  </div>

                                </v-col>
                                <v-col class="col-md-2 text-end">
                                  <span class="blue--text pointer small-text" @click="selectedArray.push(filter.distance)">Apply</span>
                                </v-col>              
                              </div>
                         </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="text-gray"> Quality Rating </v-expansion-panel-header>
                      <v-expansion-panel-content class="no-padding">
                                  
                                  <div>
                                      <v-rating
                                        @click="selectedArray.push(filter.rating)"
                                        v-model.trim="filter.rating"
                                        background-color="orange lighten-3"
                                        color="orange"
                                        
                                    ></v-rating>
                                  </div>
                         </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="text-gray"> Matching Status </v-expansion-panel-header>
                      <v-expansion-panel-content>
                          <v-radio-group v-model.trim="filter.status">
                              <v-radio
                                @click="selectedArray.push(n.text)"
                                v-for="n in filterMatchingStatus"
                                :key="n.value"
                                :label="n.text"
                                :value="n"
                              ></v-radio>
                        </v-radio-group>
                         </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="text-gray"> Preferred Provider</v-expansion-panel-header>
                      <v-expansion-panel-content>
                          <v-radio-group v-model.trim="filter.preferredProvider" >
                              <v-radio
                                @click="selectedArray.push(filter.preferredProvider)"
                                v-for="n in prefferedProviderItems"
                                :key="n.value"
                                :label="n.text"
                                :value="n"
                              ></v-radio>
                        </v-radio-group>
                         </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-expansion-panel>
                      <v-expansion-panel-header class="text-gray"> Manual Override</v-expansion-panel-header>
                      <v-expansion-panel-content>
                          <v-radio-group v-model.trim="filter.manualOverride" >
                               <v-radio
                                @click="selectedArray.push(filter.manualOverride)"
                                v-for="n in manualOverrideProviders"
                                :key="n.value"
                                :label="n.text"
                                :value="n"
                               
                              ></v-radio>
                        </v-radio-group>
                         </v-expansion-panel-content>
                    </v-expansion-panel>
             </v-expansion-panels>
          </div>
           <div class="mb-5 mt-5">
             <v-btn class="blue-buttons col-md-12" @click="filterProviders" >View Result</v-btn>
           </div>
       </div>
     </v-navigation-drawer>
     
    <div :class="overlay ? 'hideOnMoblie background-opacity col-md-9' : 'col-md-12 navigationWidth '" >
      <div class="col-md-12">
             <v-row>
        <v-col class="col-lg-3 col-md-2"  cols="12">
            <h3>
              <span class="font" >Bundles</span>
            </h3>
           
        </v-col>
        <v-col class="col-lg-3 col-md-4"  cols="12">
          <v-btn class="blue-buttons" :disabled="overlay" @click="overlay = !overlay">Group Bundles</v-btn>
        </v-col>
        <v-col class="col-lg-3 col-md-6"  cols="12">
            <v-text-field class="input-control" prepend-inner-icon="mdi-magnify" @input="searchProviders" light dense outlined placeholder="Search Bundles by Bundle Name ">
            </v-text-field>
        </v-col>
      
     
      </v-row>  
      </div>
       <v-row v-if="allProviders.length < 1 ">
         <v-col v-if="noDataMessage != ''">
              <v-col>
                  <a @click="getAllProviders"> {{noDataMessage}} </a>
              </v-col>
          </v-col>
          <v-col md="12" v-else>
              <a  @click="$router.push(`/employer/bundles/add-new`)">Upload Member Zip Codes to Create Your Custom Bundles List</a>
          </v-col>
        
      </v-row>
      <v-simple-table v-else fixed-header  :class="overlay ? 'disabled-table y-scroll ' : 'y-scroll'">
        <template v-slot:default>
          <thead :class="overlay ? 'disabled-table' : ''">
            <tr>
              <th class="text-left">
                 Procedure Description
              </th>
              <th class="text-left">
                Provider
              </th>
              <th class="text-left">
                Bundle Rate
              </th>
              <th class="text-left">
                National Avg.
              </th>
               <th class="text-left">
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item,index) in allProviders"
              :key="index"
              @click="activeRow(index,item)"
              :id="'id' + index"
            >
              <td><a  @click="singleProvider(item)" >{{ item.companyName }}</a> </td>
              
              <td class="text-gray">{{ item.type }}</td>
              <td class="text-gray">
                <v-rating
                 :value="item.qualityRating"
                  color="yellow darken-3"
                  background-color="grey darken-1"
                  empty-icon="$ratingFull"
                  half-increments
                
              ></v-rating>
              </td>
              <td class="text-gray" v-html="item.city ? item.city : '/'"></td>
              <td class="red--text" >Not Matched</td>
              <td class="text-gray">280%</td>
              <td class="text-gray">N/A</td>
   
              <td  class="text-center">
                     <svg @click="singleProvider(item)"   width="25" class="mr-2 pointer" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <rect width="25" height="25" />
                        <rect width="25" height="25" fill="url(#pattern0)"/>
                        <defs>
                          <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                          <use xlink:href="#image0_423:64" transform="scale(0.0025)"/>
                          </pattern>
                          <image id="image0_423:64" width="400" height="400" xlink:href="data:image/png;base64,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"/>
                        </defs>
                    </svg>
                    <svg width="25" class="pointer" @click="removeItem(item)" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <rect width="25" height="25"/>
                        <rect width="25" height="25" fill="url(#pattern)"/>
                        <defs>
                            <pattern id="pattern" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlink:href="#image0_423:61" transform="scale(0.0025)"/>
                            </pattern>
                            <image id="image0_423:61" width="400" height="400" xlink:href="data:image/png;base64,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"/>
                        </defs>
                     </svg>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-row class="justify-end mt-3" v-if="!noDataMessage && showSaveButton">
        <v-btn class="blue-buttons" @click="addProviders()">Save & Apply</v-btn>
      </v-row>
    </div>

     <v-dialog v-model.trim="dialog" max-width="600px" persistent>
       <v-card>
            <v-col>
                <h3>Remove Provider</h3>
            </v-col>
      
       
            <v-col>
                <span>Are you sure you want to delete this Provider?</span>
            </v-col>
       
            <v-col>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="blue-buttons float-class" @click="confirmRemove">Confirm</v-btn>
                    <v-btn class="button-style float-class" @click="closePopUp">Close</v-btn>
                </v-card-actions>
            </v-col>
        </v-card>
    </v-dialog>
 
</div>
</template>
<script>
 import api from '../../../../services/api'
 import successModal from '../../../TablesTemplate/SuccessDialog.vue'
  export default {
    components:{successModal},
    data () {
      return {
        ratingValue:2,
        items: [],
        manualOverrideProviders:[
          {
            text:'Manual Override',
            value:true
          }
        ],
        prefferedProviderItems:[
         {
            text:'Preferred Provider',
            value:true
         }
        ],
        filter : {
          type:'',
          speciality:'',
          rating:0,
          distance:'',
          status:'',
          preferredProvider:false,
          manualOverride:false,
        },
        showSaveButton:false,
        filterMatchingStatus:[
          {
            text:'Matched',
            value:'matched'
          },
           {
            text:'Not Matched',
            value:'notMatched'
          },
        ],
        noDataMessage : '',
        selectedArray:[],
        panel: [0, 1,2,3,4,5],
        providerType:[
          {
            text:'Hospital',
            value:'hospital'
          },
           {
            text:'Doctor Office',
            value:'doctorOffice'
          },
           {
            text:'Imagining',
            value:'imaging'
          },
          {
            text:'Laboratory',
            value:'laboratory'
          },
           {
            text:'Other',
            value:'other'
          },

        ],
        selectedRows:[],
        allProviders:[],
        display:true,
        overlay:false,
        windowWidth : window.innerWidth,
        dialog:false,
        filterArray:[],
        itemToRemove:null
      }
    },
    
    created(){
        if (this.windowWidth < 600) {
            this.display = false;
            } else {
            this.display = true;
        }
        this.overlay = false;
   
    },
    computed:{
      path(){
           return this.$route.path
      },
      getClient(){
          return this.$store.getters.getClientGetter
       },
       routeParams(){
            return this.$route.params.name
      },
 
       overlayClass(){
         let str = ''
         if(this.display){
              str = 'col-md-12'
              if(document.getElementById('hideOnMobile')){
                document.getElementById('hideOnMobile').style.display = 'none !important'
                
              }   
         }
          else if(this.overlay){
           str = 'col-md-9 disabled-table'
         }
         else if(!this.display){
           str = 'col-md-12'
         }else{
           str = 'col-md-12'
         }
         return str
       }
    },
    mounted() {
        this.$nextTick(() => {
          window.addEventListener('resize', this.onResize);
    })
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResize);
    },
    created(){ 
      this.getAllProviders();
     
    },

   methods:{
     removeItem(item){
        this.dialog = true;
        this.itemToRemove = item
     },
     closeSuccessModal(){
        this.$refs.success_modal.closePopUp();
        this.getAllProviders();
        this.overlay = false;
        this.showSaveButton = false;
        
      },
      clearAll(){
           this.filter.type = '';
           this.filter.distance = '';
           this.filter.rating = 0;
           this.filter.status = '';
           this.filter.preferredProvider = false;
           this.filter.manualOverride = false;


      },
      removeFilter(type){
      
       if(type == 'type'){
          this.filter.type = ''
       }else if(type == 'distance'){
         this.filter.distance = ''
       }else if(type == 'rating'){
         this.filter.rating = 0
       }else if(type == 'status'){
         this.filter.status = ''
       }else if(type == 'preferred'){
        this.filter.preferredProvider = false
       }else if(type == 'manual'){
        this.filter.manualOverride = false
       }
     },
     activeRow(index,item){
          
       let itemById = document.getElementById('id'+ index);
       itemById.classList.toggle('activeItem')
      
       if(itemById.classList.contains('activeItem')){
          this.selectedRows.push(item._id);
       }else{
         let removeItem =  this.selectedRows.find(x => x === item._id);
         this.selectedRows.splice(this.selectedRows.indexOf(removeItem),1 );

       }

     },
     addProviders(){
          let data = {
           'search':'provider',
           'ids' : this.selectedRows
          }
           let user = JSON.parse(localStorage.getItem('user'));
           let empId = user.groupPortal[0].organization.employer
          
           api().post(`/employers/${empId}/providers`, data).then((res)=>{
               let text = 'Providers added successfully to this Employer!'
               this.$refs.success_modal.openPopUp(text);
               
                
           })
     },
     filterProviders(){
        let urlData = ``
          urlData += this.filter.type ? `providerType=${this.filter.type.value}&` : ''
          urlData += this.filter.distance  ? `distance=${this.filter.distance}&` : ''
          urlData += this.filter.rating ? `qualityRating=${this.filter.rating}&` : ''
          urlData += this.filter.status ? `status=${this.filter.status.value}&` : ''
          urlData += this.filter.preferredProvider ? `preferred=${this.filter.preferredProvider.value}&` : ''
          urlData += this.filter.manualOverride ? `manualOverride=${this.filter.manualOverride.value}&` : ''
    
        api().get(`/advisors/providers/search?${urlData}`).then((res)=>{
          
               if(res){
                 if(res.data.providers.length < 1){
                       this.noDataMessage = 'No Result Found. Try Again'
                        this.allProviders = [];
                        this.showSaveButton = false;
                 }else{
                       this.allProviders = res.data.providers;
                       this.showSaveButton = true;
                 }
                 
                   this.overlay = false
                   
               }
         })
     },
     getAllProviders(){
           let user = JSON.parse(localStorage.getItem('user'));
            let empId = user.groupPortal[0].organization.employer
           
             api().get(`/employers/${empId}/providers`).then((res)=>{
               if(res){
                  this.allProviders = res.data.providers
                  this.filterArray = res.data.providers
               }
          })
     },
     searchProviders(val){
       this.allProviders = this.filterArray.filter((el)=>{
         if(el.companyName.toLowerCase().includes(val.toLowerCase())){
           return el.companyName.toLowerCase().includes(val.toLowerCase())
         }
       })
     },
   
      singleProvider(item){
        if(!this.overlay && !this.showSaveButton){
          let user = JSON.parse(localStorage.getItem('user'));
          let empId = user.groupPortal[0].organization.employer
         
             api().get(`/employers/${empId}/providers/${item._id}`).then((res)=>{
               if(res){
                
                 this.$store.commit('setSingleProviderInEmployer', res.data.provider)
                 this.$router.push(`/employer/providers/detail`);
               }
          })
           
        }
        
        
      },
      confirmRemove(){
         let user = JSON.parse(localStorage.getItem('user'));
        let empId = user.groupPortal[0].organization.employer
            api().delete(`/employers/${empId}/providers/${this.itemToRemove._id}`).then((res)=>{
                if(res){
                       api().get(`/employers/${empId}/providers`).then((res)=>{
                        if(res){
                            this.allProviders = res.data.providers
                            this.filterArray = res.data.providers
                            this.dialog = false
                        }
                    })
                }
            })
         
      },
      closePopUp(){
        this.dialog = false
      },
      openFilterMenu(){
       
        this.overlay = !this.overlay 
         this.$store.commit('showFilterMenu',this.overlay)
      },
      changeColor(status){
      let myClass = ''
       if(status == 'Matched'){
         myClass = 'red--text'
       }else if(status == 'Not matched'){
           myClass = 'green--text'
       }else{
        myClass = 'gray--text'
       }
       return myClass;
    },
     onResize() {
        this.windowWidth = window.innerWidth
        if (this.windowWidth < 600) {
          this.display = false;
        } else {
          this.display = true;
        }
      },
    },
 
  }
</script>
<style>

</style>